import { errorActions } from "@/alerts";
import axios from "@/api";
import { isSessionExpiredError } from "@/publicjs/authSession";
/**
 *
 * @param {*} access Descripción del acceso especifico del sistema
 * @param {*} idUser Id del usuario la cual sera verificado
 */
export const validateAccessSpecific = async (access, idUser) => {
  const response = await axios
    .get(`accesos-especificos/areas/?search=${access}&iduser=${idUser}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch(function (error) {
      if (isSessionExpiredError(error)) {
        return null;
      }

      errorActions(error);
      return null;
    });
  if (!response?.data) {
    return [];
  }
  const data = response.data;
  return Array.isArray(data) ? data : [];
};
